import {node_observable_component} from "common/util/ComponentDecorator";
import './checkout-steps.scss';

@node_observable_component
export default class CheckoutSteps {
	static classname = 'checkout-steps';

	constructor($steps) {
		this.$steps = $steps;
		this.bindEvents();
	}

	bindEvents() {
		this.$steps.find('.checkout-steps__step').on('click', function () {
			window.location = $(this).data('step_href');
		});
	}
}
